const CONSTANTS = module.exports = {};

CONSTANTS.ELAL_COMMISSION_RATE_HOTEL_NET = 0.067;
CONSTANTS.ELAL_TRANSACTION_FEE_RATE = 0.01;

CONSTANTS.PAYMENT_MODE_PAY_NOW = 'PAY_NOW';
CONSTANTS.PAYMENT_MODE_BNPL = 'BNPL';

// Identifies a successful BNPL charge attempt in payment.bnpl.attempts[].result
CONSTANTS.BNPL_ATTEMPT_RESULT_SUCCESS = 'success';
